import React, { useState } from "react";
import { RegularButton, RoundButton } from "components/Button";
import { ReactComponent as CallIcon } from "assets/icons/call.svg";
import { ReactComponent as BuildingIcon } from "assets/icons/building.svg";
import { ReactComponent as AppointmentIcon } from "assets/icons/appointment.svg";
import PhoneNumbersList from "./PhoneNumbersList";
import AddressesList from "./AddressesList";
import Appointments from "./Appointments";

type SelectedIcon = "call" | "building" | "appointment";

const Components = {
  call: PhoneNumbersList,
  building: AddressesList,
  appointment: Appointments,
};

const DetailSelector = () => {
  const [selected, setSelected] = useState<SelectedIcon>("call");

  const SelectedComponent = Components[selected];

  return (
    <div className="p-4">
      <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
        <div className="flex flex-wrap gap-4">
          <RoundButton
            Icon={CallIcon}
            size="large"
            iconLineType="fill"
            selected={selected === "call"}
            onClick={() => setSelected("call")}
          />

          <RoundButton
            Icon={BuildingIcon}
            size="large"
            iconLineType="fill"
            selected={selected === "building"}
            onClick={() => setSelected("building")}
          />

          <RoundButton
            Icon={AppointmentIcon}
            size="large"
            iconLineType="fill"
            selected={selected === "appointment"}
            onClick={() => setSelected("appointment")}
          />
        </div>
        <div className="flex flex-wrap gap-2">
          <RegularButton color="Secondary" onClick={() => ""}>
            <span>Add New Phone Number</span>
          </RegularButton>
        </div>
      </div>

      <SelectedComponent />
    </div>
  );
};

export default DetailSelector;
